import { Injectable } from '@angular/core';
import { ChartGroupType } from '../models/chart-group-type';
import { ArrearsFields, ArrearsField } from '../arrears-fields.provider';

const fieldToChartGroup = (field: ArrearsField, idx: number ) => {
  return { Id: idx + 1, Name: field.label, Field: field.fieldName }
}

@Injectable()
export class ChartGroupsProvider {

  private readonly allChartGroups: Array<ChartGroupType>;

  get defaultFirstGroup(): ChartGroupType {
    return this.allChartGroups[0];
  }

  get defaultSecondGroup(): ChartGroupType {
    return this.allChartGroups[1];
  }

  getGroups(): Array<ChartGroupType> {
    return this.allChartGroups;
  }

  getPropertyGroups(): Array<ChartGroupType> {
    return this.arrearsFields.propertyGroupFields.map(fieldToChartGroup);
  }

  constructor(private readonly arrearsFields: ArrearsFields) {
    this.allChartGroups = this.arrearsFields.groupFields.map(fieldToChartGroup);
  }

}
